export const ellipsis = (text: string): string => `${text}…`;
